import { AsyncStoreItem } from '@lib/store';
import { GetDocumentListTktResponse } from 'src/sdk-servicing';

/**
 * GetDocumentListTktResult model
 */
export interface GetDocumentListTktResultModel {
  model: GetDocumentListTktResponse | null;
}

/**
 * GetDocumentListTktResponse model details
 */
export interface GetDocumentListTktResultStateDetails extends AsyncStoreItem {}

/**
 * GetDocumentListTktResult store state
 */
export interface GetDocumentListTktResultState
  extends GetDocumentListTktResultStateDetails,
    GetDocumentListTktResultModel {}

/**
 * Name of the GetDocumentListTktResult Store
 */
export const GET_DOCUMENT_LIST_TKT_RESULT_STORE_NAME = 'getDocumentListTktResult';

/**
 * GetDocumentListTktResult Store Interface
 */
export interface GetDocumentListTktResultStore {
  /** GetDocumentListTktResult state */
  [GET_DOCUMENT_LIST_TKT_RESULT_STORE_NAME]: GetDocumentListTktResultState;
}
